const BACKEND = 'https://backproject.meanc.net/meanc';
const CHAT_API = 'https://chat.meanc.net/chat-api';

const authHeaders = (token) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

export const api = {
  // ── Profile ─────────────────────────────────────────────
  getProfile: (token) =>
    fetch(`${BACKEND}/users/me/profile-show/`, { headers: authHeaders(token) }).then((r) => r.json()),

  updateProfile: (token, payload) =>
    fetch(`${BACKEND}/users/me/profile/`, {
      method: 'PATCH',
      headers: authHeaders(token),
      body: JSON.stringify(payload),
    }).then((r) => r.json()),

  updateChatProfile: (token, payload) =>
    fetch(`${CHAT_API}/usersprofile/me/`, {
      method: 'PATCH',
      headers: authHeaders(token),
      body: JSON.stringify(payload),
    }).then((r) => r.json()),

  // ── Challenges ──────────────────────────────────────────
  getChallenges: (token) =>
    fetch(`${CHAT_API}/v2/challenges/`, {
      headers: token ? authHeaders(token) : { Accept: 'application/json' },
    }).then((r) => r.json()),

  vote: (token, challengeId, teamId, count = 1) =>
    fetch(`${CHAT_API}/v2/challenges/vote/`, {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify({ challenge_id: challengeId, team_id: teamId, count }),
    }).then((r) => r.json()),

  getChallenge: (token, id) =>
    fetch(`${CHAT_API}/v2/challenges/${id}/`, {
      headers: token ? authHeaders(token) : { Accept: 'application/json' },
    }).then((r) => r.json()),

  // ── Chat ────────────────────────────────────────────────
  getFollows: (token, status = 'accepted') =>
    fetch(`${CHAT_API}/follow/?status=${status}`, { headers: authHeaders(token) }).then((r) => r.json()),

  getChatDirectory: (token) =>
    fetch(`${CHAT_API}/usersprofile/chat_list/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getConversations: (token) =>
    fetch(`${CHAT_API}/conversations/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Notifications ───────────────────────────────────────
  getNotifications: (token) =>
    fetch(`${CHAT_API}/v2/notifications/`, { headers: authHeaders(token) }).then((r) => r.json()),

  markNotificationRead: (token, id) =>
    fetch(`${CHAT_API}/v2/notifications/${id}/mark_read/`, {
      method: 'POST',
      headers: authHeaders(token),
    }).then((r) => r.json()),

  markAllRead: (token) =>
    fetch(`${CHAT_API}/v2/notifications/mark_all_read/`, {
      method: 'POST',
      headers: authHeaders(token),
    }).then((r) => r.json()),

  deleteNotification: (token, id) =>
    fetch(`${CHAT_API}/v2/notifications/${id}/soft_delete/`, {
      method: 'POST',
      headers: authHeaders(token),
    }).then((r) => r.json()),

  // ── Fanzones / Teams ────────────────────────────────────────────
  getFanzones: (token) =>
    fetch(`${CHAT_API}/v2/fanzones_partial/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getFanzoneDetail: (token, id) =>
    fetch(`${CHAT_API}/v2/fanzones/${id}/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getMembershipStatus: (token, id) =>
    fetch(`${CHAT_API}/v2/fanzones/${id}/membership_status/`, { headers: authHeaders(token) }).then((r) => r.json()),

  joinFanzone: (token, id) =>
    fetch(`${CHAT_API}/v2/fanzones/${id}/join_fanzonev2/`, {
      method: 'POST', headers: authHeaders(token),
    }).then((r) => r.json()),

  getFanzoneMessages: (token, id) =>
    fetch(`${CHAT_API}/fanzones/${id}/messages/`, { headers: authHeaders(token) }).then((r) => r.json()),

  postFanzoneMessage: (token, id, message, parentId) =>
    fetch(`${CHAT_API}/fanzones/${id}/messages/`, {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify(parentId ? { message, parent: parentId } : { message }),
    }).then((r) => r.json()),

  // ── Challenge comments ───────────────────────────────────────────
  getChallengeComments: (token, id) =>
    fetch(`${CHAT_API}/v2/challenges/${id}/comments/`, {
      headers: token ? authHeaders(token) : { Accept: 'application/json' },
    }).then((r) => r.json()),

  postChallengeComment: (token, id, comment) =>
    fetch(`${CHAT_API}/v2/challenges/${id}/comments/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify({ comment }),
    }).then((r) => r.json()),

  // ── Rematch ──────────────────────────────────────────────────────
  getRematchInfo: (token, id) =>
    fetch(`${CHAT_API}/v2/challenges/${id}/rematch_request/`, { headers: authHeaders(token) }).then((r) => r.json()),

  requestRematch: (token, id) =>
    fetch(`${CHAT_API}/v2/challenges/${id}/rematch_request/`, {
      method: 'POST', headers: authHeaders(token),
    }).then((r) => r.json()),

  // ── Team suggestion ──────────────────────────────────────────────
  suggestTeam: (token, payload) =>
    fetch(`${CHAT_API}/v2/team-suggestions/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify(payload),
    }).then((r) => r.json()),

  // ── User follow ──────────────────────────────────────────────────
  followUser: (token, userId) =>
    fetch(`${CHAT_API}/follow/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify({ followed: userId }),
    }).then((r) => r.json()),

  unfollowUser: (token, userId) =>
    fetch(`${CHAT_API}/follow/unfollow/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify({ followed: userId }),
    }).then((r) => r.json()),

  getMyFollows: (token) =>
    fetch(`${CHAT_API}/follow/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Follow ──────────────────────────────────────────────
  acceptFollowRequest: (token, id) =>
    fetch(`${CHAT_API}/follow/${id}/accept/`, {
      method: 'POST',
      headers: authHeaders(token),
    }).then((r) => r.json()),

  rejectFollowRequest: (token, id) =>
    fetch(`${CHAT_API}/follow/${id}/reject/`, {
      method: 'POST',
      headers: authHeaders(token),
    }).then((r) => r.json()),

  cancelFollowRequest: (token, userId) =>
    fetch(`${CHAT_API}/follow/cancel_request/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify({ followed: userId }),
    }).then((r) => r.json()),

  // ── User profile (chat backend) ──────────────────────────
  getUserById: (token, id) =>
    fetch(`${CHAT_API}/usersprofile/${id}/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getUserFollowers: (token, id) =>
    fetch(`${CHAT_API}/usersprofile/${id}/followers/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getUserFollowing: (token, id) =>
    fetch(`${CHAT_API}/usersprofile/${id}/following/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Credits ──────────────────────────────────────────────
  getCredits: (token) =>
    fetch(`${CHAT_API}/v2/credits/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getCreditHistory: (token) =>
    fetch(`${CHAT_API}/v2/credits/history/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Blocking ─────────────────────────────────────────────
  blockUser: (token, userId) =>
    fetch(`${CHAT_API}/v2/user-blocks/`, {
      method: 'POST', headers: authHeaders(token),
      body: JSON.stringify({ blocked: userId }),
    }).then((r) => r.json()),

  unblockUser: (token, blockId) =>
    fetch(`${CHAT_API}/v2/user-blocks/${blockId}/`, {
      method: 'DELETE', headers: authHeaders(token),
    }),

  getBlockedIds: (token) =>
    fetch(`${CHAT_API}/v2/user-blocks/blocked-ids/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Notification counts ───────────────────────────────────
  getUnreadCount: (token) =>
    fetch(`${CHAT_API}/v2/notifications/unread_count/`, { headers: authHeaders(token) }).then((r) => r.json()),

  getUnreadChatCount: (token) =>
    fetch(`${CHAT_API}/v2/notifications/unread_chat_count/`, { headers: authHeaders(token) }).then((r) => r.json()),

  // ── Challenge extras ──────────────────────────────────────
  getFeaturedChallenge: (token) =>
    fetch(`${CHAT_API}/v2/challenges/featured/`, {
      headers: token ? authHeaders(token) : { Accept: 'application/json' },
    }).then((r) => r.json()),

  getTopVoters: (token, challengeId, teamId) =>
    fetch(`${CHAT_API}/v2/challenges/${challengeId}/top-voters/${teamId ? `?team_id=${teamId}` : ''}`, {
      headers: authHeaders(token),
    }).then((r) => r.json()),

  getChallengeHistory: (token, challengeId) =>
    fetch(`${CHAT_API}/v2/challenges/${challengeId}/history/`, {
      headers: token ? authHeaders(token) : { Accept: 'application/json' },
    }).then((r) => r.json()),

  // ── App store links (public) ─────────────────────────────────
  getAppStoreLinks: () =>
    fetch(`${BACKEND}/app-store-links/`, {
      headers: { Accept: 'application/json' },
    }).then((r) => r.json()),

  // ── Password reset ────────────────────────────────────────
  requestPasswordReset: (email) =>
    fetch(`https://backproject.meanc.net/meanc/password/forgot/`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }).then((r) => r.json()),

  confirmPasswordReset: (code, newPassword) =>
    fetch(`https://backproject.meanc.net/meanc/password/forgot/reset/`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, new_password: newPassword }),
    }).then((r) => r.json()),
};

export const WS_BASE = 'wss://chat.meanc.net/ws/chat';
